export const TRASH_BIN_TABLE_TYPE = 'trash';
